// The iPad's chart of Gallivant RP at anchor (TOM-980): OpenStreetMap land, the
// anchor watch's circle, her track, the boat at her recorded heading, the wind,
// a 200 ft scale bar and north. A static SVG from her record; it loads no map
// tiles. Its data credit is in the figure caption under the iPad.
import { memo } from 'react';

import { ANCHORAGE_LAND_D, ANCHORAGE_WATER_LABEL } from './anchorageLand';
import { CHART_HEIGHT, CHART_WIDTH } from './chartProjection';
import {
  CHART_ANCHOR,
  CHART_BOAT,
  CHART_CIRCLE_LABEL,
  CHART_CIRCLE_R,
  CHART_HEADING_DEG,
  CHART_SCALE_FT,
  CHART_SCALE_LENGTH,
  CHART_TRACK_D,
  CHART_WIND_ARROW,
} from './ipadChart';
import { SCENE_READINGS } from './homeScene';

const r1 = (n: number) => Math.round(n * 10) / 10;

export const HomeChart = memo(function HomeChart() {
  const scale = r1(CHART_SCALE_LENGTH);
  return (
    <svg
      className="home-chart"
      aria-hidden="true"
      viewBox={`0 0 ${CHART_WIDTH} ${CHART_HEIGHT}`}
      preserveAspectRatio="xMidYMid slice"
    >
      <rect className="home-chart__water" width={CHART_WIDTH} height={CHART_HEIGHT} />
      <path className="home-chart__land" d={ANCHORAGE_LAND_D} />
      <text
        className="home-chart__place"
        x={ANCHORAGE_WATER_LABEL.x}
        y={ANCHORAGE_WATER_LABEL.y}
        textAnchor="middle"
      >
        {ANCHORAGE_WATER_LABEL.name}
      </text>
      <circle
        className="home-chart__circle"
        cx={CHART_ANCHOR.x}
        cy={CHART_ANCHOR.y}
        r={r1(CHART_CIRCLE_R)}
      />
      <path className="home-chart__track" d={CHART_TRACK_D} />
      <g
        className="home-chart__anchor"
        transform={`translate(${CHART_ANCHOR.x} ${CHART_ANCHOR.y})`}
      >
        <circle cx="0" cy="-9" r="3.2" />
        <path d="M0 -5.8 V10" />
        <path d="M-6 0 H6" />
        <path d="M-9 4 Q-8 11 0 11 Q8 11 9 4" />
      </g>
      <g
        transform={`translate(${r1(CHART_BOAT.x)} ${r1(CHART_BOAT.y)}) rotate(${CHART_HEADING_DEG})`}
      >
        <path className="home-chart__boat" d="M0 -15 L9.5 11 L0 6.5 L-9.5 11 Z" />
      </g>
      <g
        className="home-chart__wind"
        transform={`translate(${r1(CHART_WIND_ARROW.x)} ${r1(CHART_WIND_ARROW.y)}) rotate(${CHART_WIND_ARROW.rotateDeg})`}
      >
        <path d="M0 22 V-14" />
        <path d="M-8 -6 L0 -18 L8 -6" />
      </g>
      <text
        className="home-chart__label home-chart__label--wind"
        x={r1(CHART_WIND_ARROW.x + 16)}
        y={r1(CHART_WIND_ARROW.y + 26)}
      >
        {SCENE_READINGS.windKn} kn
      </text>
      <text
        className="home-chart__label home-chart__label--circle"
        x={CHART_CIRCLE_LABEL.x}
        y={CHART_CIRCLE_LABEL.y}
        textAnchor="middle"
      >
        {SCENE_READINGS.circleFt} ft
      </text>
      <g className="home-chart__scale" transform="translate(26 556)">
        <path d={`M0 0 H${scale}`} />
        <path d={`M0 -5 V5 M${scale} -5 V5`} />
        <text className="home-chart__label" x={r1(scale + 8)} y="5">
          {CHART_SCALE_FT} ft
        </text>
      </g>
      <g className="home-chart__north" transform="translate(488 550)">
        <path d="M0 8 L7 -10 L14 8 L7 3 Z" />
        <text className="home-chart__label" x="7" y="26" textAnchor="middle">
          N
        </text>
      </g>
    </svg>
  );
});
